export const WRONG_CREDENTIALS_ERROR = "WRONG_CREDENTIALS_ERROR";
